/** Shopify product type used to identify gift box products. */ export const GIFT_BOX_PRODUCT_TYPE = 'Gift Boxes & Tins';
/** Shopify product type used to identify gift card products. */ export const GIFT_CARD_PRODUCT_TYPE = 'Gift Card';
